module.exports = __webpack_public_path__ + "static/a1-d64c17e468503449e405f287fea9d97e.png";